import "$styles/index.scss"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

import assets from '../assets/**/*.{jpg,jpeg,png,svg,woff,woff2}'
Object.entries(assets).forEach(asset => asset)

import Collapse from "node_modules/bootstrap/js/dist/collapse"
import Tab from "node_modules/bootstrap/js/dist/tab"
window.bootstrap = { Collapse, Tab }

import Typed from "node_modules/typed.js"
window.Typed = Typed

import "../assets/js/hs.core.js"
import "../assets/js/hs.typed.js"
import persist from '@alpinejs/persist'
import Alpine from "alpinejs"
import docSearch from "./search"

HSCore.init()

window.Alpine = Alpine
Alpine.plugin(persist)
Alpine.data("docSearch", docSearch)
Alpine.store('referralCode', {
    code: Alpine.$persist(null).using(sessionStorage).as('referralCode'),
    asQuery() {
      return this.code ? `?referral_code=${this.code}` : ""
    }
})
Alpine.start()
